export const usernameRegex = /^[\s\S]+$/;

export const parseRoundNumber = (input: string) => {
  const number = parseFloat(input.split(' ')[1]);
  return number;
};
